import { render, staticRenderFns } from "./UserCompareInfoModal.vue?vue&type=template&id=235cdbf2&scoped=true&"
import script from "./UserCompareInfoModal.vue?vue&type=script&lang=ts&"
export * from "./UserCompareInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserCompareInfoModal.vue?vue&type=style&index=0&id=235cdbf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235cdbf2",
  null
  
)

export default component.exports